import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import IconTopic from 'src/components/IconTopic';
import lessStyle from './index.module.less';

const localStorageKey = 'changePriceOpen1';
const FISRT_OPEN = localStorage.getItem(localStorageKey) !== 'true';

export default function ChangePrice() {
  const [open, setOpen] = useState(FISRT_OPEN);

  useEffect(() => {
    if (FISRT_OPEN) {
      setOpen(true);
      localStorage.setItem(localStorageKey, 'true');
    }
  }, []);

  return (
    <div className={lessStyle['change-price-container']}>
      <div className={lessStyle['change-price-title']} onClick={() => setOpen(true)}>
        <IconTopic type="icon-tongzhi" className={lessStyle.icon} />
        <span className={lessStyle.title}>调价通知</span>
      </div>

      <Modal
        open={open}
        footer={null}
        closable={false}
        centered
        width={800}
        wrapClassName={lessStyle.modalWrap}
        styles={{
          content: {
            padding: 0,
            background: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <div className={lessStyle.card}>

          <div className={lessStyle.header}>
            <span className={lessStyle.headerTitle}>
              关于『查询服务价格调整』的公告
            </span>
          </div>

          <div className={lessStyle.body}>
            <div className={lessStyle.salutation}>
              <span className={lessStyle.salutationIcon} aria-hidden>❤️</span>
              <strong>尊敬的iLaw用户：</strong>
            </div>
            <div className={lessStyle.paragraph}>
              首先，因不动产查询服务调整给您带来的不便，我们致以诚挚的歉意，也由衷感谢您长期以来的信任与耐心等待。 <br />
              过去数月，受官方对不动产数据查询权限、接入标准与定价体系的合规重构影响，原服务进行了全面停服与系统重整。目前，我们已完成<strong>官方授权数据源的重新接入</strong>，在新的监管框架下，正式恢复不动产查询服务，确保您的业务推进不再受服务中断影响。<br />
              根据官方统一规定，自<strong className={lessStyle.highlightDate}>2026 年 5 月 15 日 0 时</strong>
              起不动产查询服务将执行全新收费标准：
            </div>

            <div className={lessStyle.paragraph}>
              <div className={lessStyle.newPriceTextContainer}>
                <span className={lessStyle.dot} aria-hidden />
                {' '}
                <span className={lessStyle.newPriceText}>新单价：1500 元 / 人 / 次（查询到 / 未查询到房产信息，均按此标准统一收取）</span>
              </div>
            </div>

            <section className={lessStyle.section}>
              <p>针对调整前已预充值余额的用户，我们提供两种处理方案，您可按需选择：</p>
              <p><strong>方案一：继续使用：</strong>账户余额按新单价 1500 元 / 人 / 次正常扣费，服务不受影响。</p>
              <p><strong>方案二：申请退费：</strong>未使用的充值余额，可按流程申请办理退费。</p>
            </section>

            <section className={lessStyle.section}>
              <h3 className={lessStyle.sectionTitle}>关于服务说明：</h3>
              <p className={lessStyle.sectionLine}>
                本服务的数据能力由官方统一授权提供，定价标准与接入规则均遵循官方要求制定，我们会在可把控的范围内，持续优化查询效率与服务体验，为您的执业提供稳定支持。
              </p>
              <p className={lessStyle.sectionLine}>
                您可通过「账户余额 - 扣减记录」查看历史消费明细，如有疑问或需办理退费，可联系客服咨询处理。
              </p>
              <p className={lessStyle.sectionLine}>
                再次感谢您的理解与支持！
              </p>
            </section>
            <div className={lessStyle.cornerText}>2026年4月30日</div>
          </div>

          <div className={lessStyle.footer}>
            <button type="button" className={lessStyle.closeBtn} onClick={() => setOpen(false)}>
              我已知晓
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
